if (!customElements.get('nosht-shoppable-gallery')) {
  customElements.define(
    'nosht-shoppable-gallery',
    class NoshtShoppableGallery extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        this.toggles = [...this.querySelectorAll('[data-product-toggle]')];

        this.addEventListener('click', this.onClick.bind(this), { signal: this.abortController.signal });
        this.addEventListener('keydown', this.onKeydown.bind(this), { signal: this.abortController.signal });
        document.addEventListener('click', this.onDocumentClick.bind(this), { signal: this.abortController.signal });
        document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this), {
          signal: this.abortController.signal,
        });

        this.dataset.ready = 'true';
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      onClick(event) {
        const toggle = event.target.closest('[data-product-toggle]');

        if (toggle && this.contains(toggle)) {
          event.preventDefault();
          this.toggleCard(toggle);
          return;
        }

        if (!event.target.closest('[data-product-card]')) this.closeAll();
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.closeAll();
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;

        const expandedToggle = this.querySelector('[data-product-toggle][aria-expanded="true"]');
        if (!expandedToggle) return;

        this.closeAll();
        expandedToggle.focus();
      }

      onBlockSelect(event) {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;

        const selectedItem = this.querySelector(
          `[data-block-id="${CSS.escape(event.detail?.blockId || '')}"]`,
        );
        const toggle = selectedItem?.querySelector('[data-product-toggle]');

        if (toggle) this.openCard(toggle);
      }

      toggleCard(toggle) {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          this.closeCard(toggle);
        } else {
          this.openCard(toggle);
        }
      }

      openCard(toggle) {
        const card = this.getCard(toggle);
        if (!card) return;

        this.closeAll(toggle);
        card.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      closeCard(toggle) {
        const card = this.getCard(toggle);
        if (card) card.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      closeAll(exceptToggle = null) {
        this.toggles.forEach((toggle) => {
          if (toggle !== exceptToggle) this.closeCard(toggle);
        });
      }

      getCard(toggle) {
        const cardId = toggle.getAttribute('aria-controls');
        if (!cardId) return null;

        return this.querySelector(`#${CSS.escape(cardId)}`);
      }
    },
  );
}
